<template>
  <div class="form-group row">
    <label class="col-12">Número Caixa: <span class="text-danger">*</span></label>
    <div class="col-sm-12">
      <div class="form-group input-group" :class="{
        'form-group--error': $v.arquivar.caixa.$error
      }">
        <input type="number" class="form-control" v-model="$v.arquivar.caixa.$model">
      </div>
      <div class="error" v-if="!$v.arquivar.caixa.required">O campo é obrigatório</div>
    </div>

    <label class="col-12">Localização: </label>
    <div class="col-sm-12">
      <div class="form-group input-group">
        <input type="text" class="form-control" v-model="arquivar.localizacao">
      </div>
    </div>

    <label class="col-12">Conclusão: <span class="text-danger">*</span></label>
    <div class="col-sm-12">
      <div class="form-group input-group" :class="{
        'form-group--error': $v.arquivar.conclusao.$error
      }">
        <textarea
          class="form-control"
          rows="3"
          v-model.trim="$v.arquivar.conclusao.$model"
        />
      </div>
      <div class="error" v-if="!$v.arquivar.conclusao.required">O campo é obrigatório</div>
    </div>

    <div class="col-12" v-if="progress.is" :key="progress.key">
      <hr>
      <div v-for="processo in $store.getters.getDataTableChecked" :key="getKey(processo.data.atributos.numeroProcesso)">
        <span>{{ formatarProtocolo(processo.data.atributos.numeroProcesso) }}</span>
        <span
          v-if="isVisibleTryAgainArquivar(processo.data.atributos.numeroProcesso)"
          class="badge badge-info link"
          @click="arquivarTramitacao(processo.data.atributos.numeroProcesso)"
        >
          <i class="fa fa-refresh" aria-hidden="true"></i> Arquivar novamente
        </span>
        <progress-bar
          :key="getKey(processo.data.atributos.numeroProcesso)"
          :percentage="getProgress(processo.data.atributos.numeroProcesso)"
          :danger="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
          :warning="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
          :success="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
          :animated="true"
          class="mt-1 mb-3"
        />
      </div>
      <div class="col-12 text-right mb-2" v-if="progress.finished && processos.length !== progress.sucesso">
        <span class="badge badge-info text-left">Alguns protocolos não foram concluidos<br> Tente novamente os protocolos com erro</span>
      </div>
    </div>

    <div class="modal-body text-md-right text-sm-center">
      <button v-if="!progress.is" type="button" class="btn btn-outline-danger m-1" @click.prevent="() => {
          closeModalEvent()
        }">Cancelar</button>
      <button v-if="progress.is" type="button" class="btn btn-outline-danger m-1" @click.prevent="() => {
          closeModalEvent()
        }">Fechar</button>
      <button v-if="!progress.is" type="button" class="btn btn-outline-primary m-1" @click.prevent="persistirArquivamento()">Prosseguir</button>
      <button v-if="progress.is" type="button" class="btn btn-outline-dark m-1">Prosseguir</button>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import VirtusService from '@/services/VirtusService'
import progressBar from '@/components/progressBar/ProgressBar'

import { protocoloParse } from '@/uteis/converters/ProtocoloConverter'

export default {
  name: 'arquivar',

  components: {
    progressBar
  },

  props: {
    closeModalEvent: { required: true, type: Function },
    protocolo: { required: false, type: String },
    atualizarConsulta: { required: true, type: Function }
  },

  data () {
    return {
      arquivar: {
        caixa: '',
        localizacao: '',
        conclusao: ''
      },
      progress: {
        isArquivar: false,
        is: false,
        background: false,
        finished: false,
        length: 0,
        sucesso: 0,
        key: false,
        alert: {
          type: 'light',
          texto: 'Arquivando os protocolos:'
        },
        processos: {}
      }
    }
  },

  validations: {
    arquivar: {
      caixa: {
        required
      },
      conclusao: {
        required
      }
    }
  },

  created () {
    this.service = new VirtusService()
  },

  destroyed () {
    this.closeModalEvent()
  },

  methods: {
    async persistirArquivamento () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.progress = {
        ...this.progress,
        isArquivar: true,
        is: true,
        background: true,
        key: !this.progress.key,
        alert: {
          type: 'light',
          texto: 'Recebendo/Atribuindo os protocolos:'
        }
      }

      const dataTable = this.$store.getters.getDataTableChecked
      for (const value of dataTable) {
        const numeroProcesso = value.data.processo
        await this.arquivarTramitacao(numeroProcesso)
      }
    },

    async arquivarTramitacao (numeroProcesso) {
      try {
        this.atualizarProgress(numeroProcesso, {
          porcentagem: '50%',
          status: 'warning'
        })
        const dadosSessao = this.$store.getters.getDadosSessao.sessao
        await this.service.arquivarProtocolo({
          ...this.arquivar,
          numeroProcesso: numeroProcesso
        }, dadosSessao)
        this.atualizarProgress(numeroProcesso, {
          porcentagem: '100%',
          status: 'success'
        })
      } catch (error) {
        this.atualizarProgress(numeroProcesso, {
          porcentagem: '100%',
          status: 'danger'
        })
      }
    },

    atualizarProgress (numeroProcesso, obj) {
      this.progress.processos[numeroProcesso] = obj
      this.progress.key = !this.progress.key
    },

    getProgress (numeroProcesso) {
      const processo = this.progress.processos[numeroProcesso]
      return processo ? processo.porcentagem || '0%' : '0%'
    },

    getKey (numeroProcesso) {
      return `${numeroProcesso}-${this.getProgress(numeroProcesso)}`
    },

    getStatus (numeroProcesso) {
      const processo = this.progress.processos[numeroProcesso]
      return processo ? processo.status || 'info' : 'info'
    },

    isVisibleTryAgainArquivar (numeroProcesso) {
      if (!this.progress.isArquivar) {
        return false
      }
      return this.getStatus(numeroProcesso) === 'danger'
    },

    formatarProtocolo (protocolo) {
      return protocoloParse(protocolo).value
    }
  }
}
</script>
